import { filter, map } from 'lodash'

import { showErrorNotification } from '../../common/helpers'

import { mergeArrayOfObjects } from '../utils'

// In order to be able to use fragments on unions or interfaces we have to provide the client with the schema info
// Reference https://www.apollographql.com/docs/react/data/fragments/#using-fragments-with-unions-and-interfaces
const getPossibleGraphqlTypes = async graphqlUri => {
  try {
    const schema = await fetch(graphqlUri, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        variables: {},
        query: `
              {
                __schema {
                  types {
                    kind
                    name
                    possibleTypes {
                      name
                    }
                  }
                }
              }
            `,
      }),
    })
    const result = await schema.json()

    return mergeArrayOfObjects(
      map(
        filter(
          result.data.__schema.types,
          ({ possibleTypes }) => possibleTypes,
        ),
        ({ name, possibleTypes }) => ({
          [name]: map(possibleTypes, 'name'),
        }),
      ),
    )
  } catch (error) {
    showErrorNotification({
      title: 'Error starting app',
      description:
        'Introspection did not work, some features might not be available until you refresh the app',
    })
  }

  return {}
}

export default getPossibleGraphqlTypes
